<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <!--资料设置-->
    <!--标题-->
    <p class="fav_mainHead">
      资料设置
      <a style="font-size: 14px; float: right; cursor: pointer; color: #E72B12;" @click="showInfo">
        <i class="el-icon-edit-outline"></i>&nbsp;完善个人资料
      </a>
    </p>
    <!--内容-->
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_one.png" />
        </div>
        <span class="font16">用户名：<span v-if="userInfo && userInfo.username">{{userInfo.username}}</span></span>
      </div>
    </div>
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_one.png" />
        </div>
        <span class="font16">昵称：<span v-if="userInfo && userInfo.nickname">{{userInfo.nickname}}</span><span v-if="!userInfo || !userInfo.nickname">游客</span></span>
      </div>
      <a class="form_modify" href="javascript:void(0);" @click="changeNickname">
        修改
      </a>
    </div>
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_three.png" />
        </div>
        <div class="flex_column">
          <span class="font16">密码</span>
          <span class="fontFourteen color_777">用于保护账号信息和登录安全</span>
        </div>
      </div>
      <a class="form_modify"  href="javascript:void(0);" @click="changePwd">
        修改
      </a>
    </div>
    <div class="rdiv pt10" style="padding-left: 35px; padding-right: 16px;">
      <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'head'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
      <img v-if="userInfo.head && userInfo.head!==''" :src="userInfo.head" width="151" height="151" style="position: absolute; left: 220px; top: 10px;" />
      <p class="mt10"><span class="tips_text">建议图片长151px宽151px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
    </div>
    <!--/资料设置-->
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import $ from 'jquery'
  import { saveCookie, getCookie } from '@/utils/cookies'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  import InfoBox from '@/components/byl/InfoBox/index.vue'
  import Bus from '@/utils/bus'
  import { mapState, mapActions } from 'vuex'
export default {
  components: { UploadOSS },
  data () {
    return {
      userInfo: {},
      uploadOSSConf: { showMode: '1', style: 'img_upload4', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  created () {
    if (!this.user) {
      this.getUserInfo(getCookie(process.env.USERID_KEY))
    } else {
      this.userInfo = this.user
    }
  },
  mounted () {
    this.getSTS()
    this.OSSUploadSuccess()
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('orgstructure', {
      addPerson: 'addPerson'
    }),
    ...mapActions('auth', {
      getMemberByUserId: 'getMemberByUserId'
    }),
    getUserInfo (id) {
      this.$api.get(this.$global.bylBaseCenterPath, '/user/' + id, {}, r => {
        if (r.data) {
          this.userInfo = r.data
        }
      })
    },
    confirmBox (o) {
      var that = this
    this.$modal.show('dialog', {
      title: o.title,
      text: o.text,
      buttons: [
        {
          title: '确认',
          default: true,
          handler: utils.debounce(() => {
            if (o.yes && o.yes instanceof Function) {
               o.yes()
              // o.yes()
              // that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
            }
          }, 1000)
        },
        {
          title: '取消'
        }
      ]
    })
  },
    changePwd () {
      var that = this
      this.confirmBox({
        title: '修改密码',
        text: '<input id="uc-pwd" type="password" placeholder="密码需包含大小写字母、数字、特殊字符，长度不少于6位" class="put_495" style="width: 250px;" minlength="6" />',
        yes: function () {
          var o = {
            password: $('#uc-pwd').val(),
            userId: that.userInfo.id
          }
          // if (o.password.length < 6) {
          //   that.$toasted.show('密码长度不能小于6位')
          // } 
          if(!(/\d/.test(o.password))){
            that.$toasted.show('需要1位数字')
          }else
           if(!(/[A-Za-z]/.test(o.password))){
              that.$toasted.show('需要1位字母')
          }else
           if(!(/[@#$%]/.test(o.password))){
              that.$toasted.show('需要1位特殊字符')
          }else
           if(!(/^.{6,20}$/.test(o.password))){
              that.$toasted.show('密码长度6到20')
          }
          else {
            api.post(config.bylBaseCenterPath, '/user/edit/password', o, function (r) { // 正常
              that.$toasted.show('修改密码成功')
              that.$modal.hide('dialog')
            })
          }
        }
      })
    },
    changeNickname () {
      var that = this
      this.confirmBox({
        title: '修改昵称',
        text: '<input id="uc-nickname" type="text" class="put_495" style="width: 250px;" />',
        yes: function () {
          var o = {
            nickname: $('#uc-nickname').val()
          }
          api.post(config.bylBaseCenterPath, '/user/edit/' + that.userInfo.id, o, function (r) { // 正常
            that.$toasted.show('修改昵称成功')
            // var u = getCookie('user')
            that.userInfo.nickname = o.nickname
            if (that.user) {
              saveCookie('user', that.userInfo)
            }
            Bus.$emit('userinfo-updated', that.userInfo)
            that.$modal.hide('dialog')
          })
        }
      })
    },
    updateAvatar (path) {
      var that = this
      api.post(config.bylBaseCenterPath, '/user/uploading', {path: path}, function (r) { // 正常
        that.$toasted.show('修改头像成功')
        // var u = getCookie('user')
        that.userInfo.head = path
        if (that.user) {
          saveCookie('user', that.userInfo)
        }
        Bus.$emit('userinfo-updated', that.userInfo)
        that.$modal.hide('dialog')
      })
    },
    OSSUploadSuccess (r) {
      if (r && r != '') {
        this.updateAvatar(r.res.requestUrls[0])
      }
    },
    getSTS () {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    showInfo () {
      var that = this
      var d = []
      this.getMemberByUserId(this.userInfo.id).then((r) => {
        if (r) {
          d = r
        }
        this.$modal.show(ModalBox, {
          opts: {
            title: '完善个人资料',
            styles: {
              width: '670',
              height: String(0.6181 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'infobox',
              template: InfoBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                data: d,
                editMode: false
              } // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              val.data.loginUserId = that.userInfo.id
              val.data.depList = [{depId: ''}] // 不传会报错
              if (val) {
                if (val.isValidate) {
                  that.addPerson(val.data) // 调用接口保存
                  that.$toasted.show('保存成功')
                } else {
                  that.$toasted.show('请填写信息')
                  that.showInfo()
                }
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/Set.vue